<!-- 我的页面 -->
<template>
  <div class v-show="returnData.display">
    <!-- 滑动显示-->
    <div class="display-title" v-if="returnData.name">
      {{ returnData.name }}
    </div>
    <swiper class="good-swiper" :options="goodswiperOption" v-if="true">
      <!-- 分3种情况 1个 -->
      <template v-if="returnData.nextDetailsDTOs[0].baseList.length == 0">
        <swiper-slide v-for="(item, index) in 3" :key="index">
          <!-- <div class="deaultimgwrap"> -->
          <div class="auto-height nolist">
            <div class="covers">
              <img
                class="deaultimg"
                src="@/assets/image/tbm/defaultsmallicon.png"
              />
            </div>
            <!-- </div> -->
          </div>
          <div class="goodinfo">
            <div class="good_name">商品名称</div>
            <div class="good_price">¥0</div>
          </div>
        </swiper-slide>
      </template>
      <template v-if="returnData.nextDetailsDTOs[0].baseList.length > 0">
        <swiper-slide
          :class="['good-display', item.imgLoaded ? 'imgloaded' : '']"
          v-for="(item, index) in returnData.nextDetailsDTOs[0].baseList"
          :key="item.id"
          v-show="!(returnData.nextDetailsDTOs[0].sellOut=='HIDE'&&item.stock==0)"
        >
         <div class="sellouttip" v-if="item.stock==0">{{ returnData.nextDetailsDTOs[0].ysjShow=='JQQD'?'... 敬请期待 ...':'... 暂时售罄 ...' }}</div>
          <!-- <div class="imgwrap"> -->
          <div class="auto-height" @click="goPDP(item, item, index)">
            <div class="covers">
              <img class="img" :src="item.imgLoaded ? item.url : ''" />
            </div>
            <!-- </div> -->

            <!-- </div> -->
          </div>
          <div class="goodinfo" @click="goPDP(item, item, index)">
            <div class="good_name">{{ item.name }}</div>
            <template
              v-if="
                item.discountPrice != '0' &&
                item.discountPrice != undefined 
              "
            >
              <div class="originprice">
                ¥{{ $utils.toThousands(item.leastPrice) }}
              </div>
              <div class="currprice">
                ¥{{ $utils.toThousands(item.discountPrice) }}
              </div>
            </template>
            <template v-else>
              <div class="currprice">
                ¥{{ $utils.toThousands(item.leastPrice) }}
                <span v-if="item.leastPrice.indexOf('起') != -1 ? true : false"
                  >起</span
                >
              </div>
            </template>
          </div>
        </swiper-slide>
      </template>
      <!-- <template
        v-if="returnData.nextDetailsDTOs[0].baseType=='COLLECTION'&&returnData.nextDetailsDTOs[0].baseList.length>0"
      >
        <swiper-slide v-for="(item,index) in returnData.nextDetailsDTOs[0].baseList" :key="index">
          <div class="imgwrap">
            <img class="img" :src="item.url" />
          </div>
          <div
            class="goodinfo"
            :class="{left:returnData.nextDetailsDTOs[0].location=='LEFT'?true:false}"
          >
            <div class="good_name">{{item.name}}</div>
            <div class="good_price">¥{{item.leastPrice}}</div>
          </div>
        </swiper-slide>
      </template>-->
    </swiper>
    <!-- 列表显示-->
    <div class="good-list" v-else>
      <template
        v-if="
          returndata.baseList.length == 0 && returndata.baseList.length == 0
        "
      >
        <div class="good-item" v-for="(item, index) in 3" :key="index">
          <div class="deaultimgwrap">
            <img
              class="deaultimg"
              src="@/assets/image/tbm/defaultsmallicon.png"
            />
          </div>
          <div class="goodinfo">
            <div class="good_name">商品名称{{ index }}</div>
            <div
              class="good_price"
              v-if="returndata.display.indexOf('price') > -1"
            >
              ¥0
            </div>
          </div>
        </div>
      </template>
      <template
        v-if="
          returndata.goodbytype == 'product' && returndata.baseList.length > 0
        "
      >
        <div
          class="good-item"
          v-for="(item, index) in returndata.baseList"
          :key="index"
        >
          <div class="imgwrap">
            <img class="img" :src="item.url" />
          </div>
          <div class="goodinfo">
            <div class="good_name">{{ item.name }}{{ index }}</div>
            <div class="good_price">¥{{ item.leastPrice }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'

export default {
  // import引入的组件需要注入到对象中才能使用
  name: "GoodDisplay",
  components: {},
  props: {
    returnData: {
      type: Object,
      required: false,
    },
    componentIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    // 这里存放数据
    return {
      ossSuffix:this.$store.state.ossSuffix,
      ossSuffixOriginSuff:this.$store.state.ossSuffixOriginSuff,
      goodswiperOption: {
        observer: true, //轮播元素为内部动态添加必须加此 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        slidesPerView: 1.333,
        spaceBetween: 18,
      },
    };
  },
  // 监控data中的数据变化
  watch: {
    returnData: {
      immediate: true,
      handler(val, oldVal) {},
      deep: true, //true 深度监听
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if(this.$utils.isMobile()){
      this.ossSuffix = "?x-oss-process=style/tb_mobilehp_cd_700"; 
    }
    this.reInitData();
    this.loadImages(0);
    // this.reLoadImage();
    this.gaViewItem();
    // var swiper = new Swiper(".swiper-container", {
    //   pagination: ".swiper-pagination",
    //   slidesPerView: 2,
    //   paginationClickable: true,
    //   slidesPerView: "auto",
    //   spaceBetween: 30,
    //   freeMode: true
    // });
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    reInitData(){
      var that = this;
      let list = that.returnData.nextDetailsDTOs[0].baseList;
      for (let m = 0; m < list.length; m++) { 
        let flag = that.$utils.checkIsUpdatetoWebp(this, list[m].url);
        if(flag){
          list[m].url = this.$utils.replaceImage( list[m].url)+this.ossSuffix;
        }else{
          list[m].url = this.$utils.replaceImage( list[m].url)+this.ossSuffix+this.ossSuffixOriginSuff;
        }
       
      }
    },
    reLoadImage() {
      var that = this;
      let list = that.returnData.nextDetailsDTOs[0].baseList;
      for (let m = 0; m < list.length; m++) {
        let img = new Image();
        img.src = list[m].url;
      }
    },
    loadImages(c) {
      if (this.returnData.nextDetailsDTOs[0].baseList[c].imgLoaded) {
        return false;
      }
      var that = this;
      var img = new Image();
      let i = c;
      img.onload = function () {
        // console.log("onload: " + i, "time: " + new Date(), "i shi:", 'id:',that.returnData.id);
        //检测是否支持webp格式
        let imgsec = that.returnData.nextDetailsDTOs[0].baseList[i].url;
         
        that.$set(
          that.returnData.nextDetailsDTOs[0].baseList[i],
          `imgLoaded`,
          true
        );
        if (i == 0 && this.componentIndex == 0) that.$emit("loadingFun");
        let count = i + 1;
        if (count < that.returnData.nextDetailsDTOs[0].baseList.length) {
          that.loadImages(count);
        }
      };
      img.onerror = function () {
        that.$set(
          that.returnData.nextDetailsDTOs[0].baseList[i],
          `imgLoaded`,
          true
        );
        if (i == 0 && this.componentIndex == 0) that.$emit("loadingFun");
        let count = i + 1;
        if (count < that.returnData.nextDetailsDTOs[0].baseList.length) {
          that.loadImages(count);
        }
      };
      // img.src = that.returnData.nextDetailsDTOs[0].baseList[i].url;

      let flag = that.$utils.checkIsUpdatetoWebp(
        this,
        that.returnData.nextDetailsDTOs[0].baseList[i].url
      );
      img.src = that.returnData.nextDetailsDTOs[0].baseList[i].url 
      
    },

    goPDP(item, good, index) {
      this.gaSelectContent(good, index);
      this.$router.push({
        name: "shopping",
        params: {
          friendly_url: item.friendlyUrl,
        },
      });
    },

    //GA select_content埋点
    gaSelectContent(good, index) {
      if (this.$route.name == "home") {
        this.$set(good, "list_name", "hp_productdisplay");
      } else {
        return;
      }
      this.$set(good, "list_position", index);
      this.$gaAction.select_content(good);
    },

    //view_item的ga埋点
    gaViewItem() {
      if (document.body.clientWidth < 768) {
        console.log(this.$route.name);
        if (this.returnData.nextDetailsDTOs[0].baseList != 0) {
          let gaUrl = "";
          if (this.$route.name == "home") {
            gaUrl = "hp_productdisplay";
          } else {
            return;
          }
          this.$gaAction.view_item(
            this.returnData.nextDetailsDTOs[0].baseList,
            gaUrl
          );
        }
      }
    },
  },
};
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
.display-title {
  padding: 0 2rem 2.8rem;
  text-align: left;
  font-size: 1.8rem;
  color: #000;
  font-family: ArialNarrow, sans-serif;
}
.good-swiper {
  padding: 0 2rem 2.8rem;
}
.swiper-container {
  width: 100%;
  height: 100%;
  .good-display {
    opacity: 0;
    &.imgloaded {
      opacity: 1;
      transition: opacity 0.3s ease-in-out 0.3s;
    }
  }
}
.good-list {
  display: flex;
  flex-wrap: wrap;
  padding: 2rem 1rem;
  .good-item {
    width: 50%;
    padding: 0 1rem;
    margin-bottom: 2rem;
  }
}

.imgwrap {
  min-height: 34rem;
  height: auto;
  background: gainsboro;
  .img {
    width: 100%;
    min-height: 34rem;
    height: auto;
    object-fit: cover;
  }
}

// .deaultimgwrap {
//   width: 100%;
//   height: 32.8rem;
//   background: #e3f0ff;
//   position: relative;
// }
.img-cover {
}
.auto-height {
  display: block;
  width: 100%;
  height: 0;
  padding-bottom: 133%;
  // background: center no-repeat #ffffff;
  background: white;
  background-size: contain;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &.nolist {
    background: #e3f0ff;
  }
  &:hover {
    filter: initial;
  }
  .covers {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .banner-img {
    min-height: 3rem;

    max-width: 100%;
    vertical-align: middle;
    object-fit: cover;
  }
}
.deaultimg {
  width: 3.5rem;
  height: 3.5rem;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.goodinfo {
  text-align: center;
  margin-top: 9px;
  color: #5c5d5f;
  &.left {
    text-align: left;
  }
  .good_name {
    font-weight: 400;
    font-family: ArialNarrow, sans-serif;
    font-size: 1.4rem;
    color: #000000;
  }
  .good_price {
    display: block;
  }
}
.sellouttip{
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;
  color: rgba(211,211,211,1);
}
</style>



// WEBPACK FOOTER //
// src/components/common/customize/GoodDisplay.vue